import React, { useEffect, useRef, useState } from "react";
import "./table.css";
import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import {
  currentOrderList,
  fetchOrderRemarksList,
} from "../../redux/actions/orderActions";
import CurrentOrdersTableData from "./currentOrderTableData";
import LoadingSpinnerTable from "../utilites/loader";
import UpArrow from "../../../src/assets/up-arrow.png";
import DownArrow from "../../../src/assets/down-arrow.png";
import searcher from "../../assets/searchInput.svg";
import NumberPagination from "../Pagination/number-pagination";
import { useLocation, useNavigate } from "react-router-dom";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    maxWidth: "50rem",
    height: "28rem",
    overflowY: "auto",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const CurrentOrdersTable = ({ maxWidth = "100%", location }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  const filterdData = {
    status: queryParamsData.get("status") ?? "",
  };
  const orderStatusArray = filterdData?.status
    ? filterdData?.status?.split(",")
    : [];
  const [status, setStatus] = useState(orderStatusArray ?? []);
  const [page, setPage] = useState(page_no ?? 1);
  const [loading, setLoading] = useState(false);
  const [currentOrderListData, setCurrentOrderListData] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [remarksList, setRemarksList] = useState([]);
  const componentRef = useRef(null);
  const tableRef = useRef(null);

  useEffect(() => {
    if (filterdData?.status) {
      setStatus(filterdData?.status?.split(","));
    } else if (filterdData?.status === undefined) {
      setStatus([]);
    } else {
      setStatus([]);
    }
  }, [filterdData?.status]);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    dispatch(fetchOrderRemarksList(onListSuccess, onListError));
  }, [dispatch]);

  const onListSuccess = (data) => {
    console.log(data, "df");
    setRemarksList(data);
  };
  const onListError = (err) => {
    console.log(err);
  };

  useEffect(() => {
    let status = orderStatusArray?.join(",");
    setLoading(true);
    if (location.pathname == "/current-orders") {
      dispatch(currentOrderList({ page, search, status }, onSuccess, onError));
    }
  }, [location, page, filterdData?.status]);

  const fetchOrderList = () => {
    dispatch(currentOrderList({ page, search }, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data.pagination);
    setCurrentOrderListData(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const handleCheckboxChange = (value) => {
    if (status.includes(value)) {
      setStatus(status.filter((item) => item !== value));
    } else {
      setStatus([...status, value]);
    }
  };

  const handleButtonClick = () => {
    navigate(
      `/current-orders?page=1${
        search ? `&search=${search}` : ""
      }&status=${status}`
    );
    setOpenStatus(!openStatus);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (filterdData?.status) queryParams.push(`status=${filterdData?.status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div className="">
        <div
          className="search-container d-flex justify-content-between align-items-center position-sticky top-0 bg-white"
          style={{ zIndex: "10" }}
        >
          <div className="search-box d-flex align-items-center p-1 ms-2 mb-2">
            <img className="styled-SVG" src={searcher} color={""} />
            <input
              value={search}
              className="search-input text-dark fw_400 px-2"
              type="text"
              placeholder="Search Order ID, etc. "
              onChange={(e) =>
                navigate(
                  `/current-orders?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }`
                )
              }
            />
          </div>
        </div>
        <TableContainer maxWidth={maxWidth} ref={tableRef}>
          <table className="main-table fs_10 text-nowrap">
            <thead>
              <tr className="table-rows">
                <th className="main-table-heads" width={"2%"}>
                  #
                </th>
                <th className="main-table-heads" width={"7%"}>
                  Order ID
                </th>
                <th className="main-table-heads text-nowrap" width={"9%"}>
                  Order Date and Time
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Doctor Name
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Pharmacy Name
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Company Name
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Division
                </th>
                <th className="main-table-heads text-nowrap" width={"8%"}>
                  City
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Value Of Order(ex. GST)
                </th>
                <th
                  className="main-table-heads text-nowrap"
                  width={"8%"}
                  ref={componentRef}
                >
                  <span
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                  >
                    Order Status
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className=" position-relative">
                      <div
                        className="position-absolute order-status-container gap-3 p-3"
                        style={{ right: "-2rem" }}
                      >
                        <div className="d-flex align-items-center flex-wrap">
                          {FilterOrder.map((option) => (
                            <div key={option.value} className="col-6 my-1">
                              <input
                                type="checkbox"
                                className="ffCheck"
                                id={option.value}
                                value={option.value}
                                checked={status.includes(option.value)}
                                onChange={() =>
                                  handleCheckboxChange(option.value)
                                }
                              />
                              <label
                                htmlFor={option.value}
                                className="mx-2 color_747f9e fw_400"
                              >
                                {option.name}
                              </label>
                            </div>
                          ))}
                        </div>
                        <div className="d-flex justify-content-end gap-3 py-2 pt-3">
                          <button
                            className="clear-btn fs_14 px-3 py-1"
                            onClick={() => {
                              setStatus([]);
                              navigate(
                                `/current-orders?page=1${
                                  search ? `&search=${search}` : ""
                                }`
                              );
                              setOpenStatus(!openStatus);
                            }}
                          >
                            CLEAR
                          </button>
                          <button
                            className="filter-btn fs_14 fw_500 px-3"
                            onClick={handleButtonClick}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="main-table-heads text-nowrap" width={"12%"}>
                  Order Remarks
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Actions
                </th>
              </tr>
            </thead>

            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : currentOrderListData?.orders?.length > 0 ? (
                <>
                  {currentOrderListData.orders?.map((ele, index) => (
                    <CurrentOrdersTableData
                      data={ele}
                      index={index}
                      key={ele.id}
                      remarksList={remarksList}
                      fetchOrderList={fetchOrderList}
                      currentPage={
                        currentOrderListData?.pagination?.currentPage
                      }
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </TableContainer>
      </div>
      {currentOrderListData?.pagination?.totalPages > 0 && (
        <NumberPagination
          setCurrentPage={setPage}
          pagination={currentOrderListData?.pagination?.currentPage}
          totalPages={currentOrderListData?.pagination?.totalPages}
          path={`/current-orders`}
          filters={`${queryString}`}
        />
      )}
    </>
  );
};

export default CurrentOrdersTable;

const FilterOrder = [
  {
    name: "Pending",
    value: "pending",
  },
  {
    name: "Approved",
    value: "approved",
  },
  {
    name: "Fully invoiced",
    value: "fully_invoiced",
  },
  {
    name: "Partially invoiced",
    value: "partially_invoiced",
  },
  {
    name: "Acknowledged",
    value: "acknowledged",
  },
  {
    name: "Partially acknowledged",
    value: "partially_acknowledged",
  },
];
